require('./telestrateControlsController');

angular.module('app.player.telestrate.telestrateControlsDirective', [
  'app.player.telestrate.telestrateControlsController'
])
.directive('telestrateControls', [
    function() {
      "use strict";

      return {
        restrict: 'EA',
        templateUrl: 'components/player/telestrate/telestrateControls/telestrateControlsView.html',
        controller: 'app.player.telestrate.telestrateControlsController',
        scope: {
          toolbox: '='
        }
      };
    }
]);


// WEBPACK FOOTER //
// ./app.v2/components/player/telestrate/telestrateControls/telestrateControlsDirective.js